module.exports = __webpack_public_path__ + "img/250212_bsplus_logotypes_bs-type_rgb_200x50px-7.1920e8db.png";